import { toast } from "react-toastify";

export const showSuccessToast = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
    style: {
      backgroundColor: "#fff",
      color: "#333",
      border: "1px solid #614438",
      zIndex: 9999,
      borderRadius: "12px",
      boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    },
  });
};

export const showErrorToast = (
  message: string,
  toastId: string = "error-toast"
) => {
  toast.dismiss(toastId);
  toast.error(message, {
    toastId,
    position: "top-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
    style: {
      backgroundColor: "#fff",
      color: "#333",
      border: "1px solid #C29363",
      zIndex: 10000,
    },
    role: "alert",
  });
};
